import { render } from "./ChoosePackageStepComponent.vue?vue&type=template&id=ba0e6890&ts=true"
import script from "./ChoosePackageStepComponent?vue&type=script&lang=ts"
export * from "./ChoosePackageStepComponent?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__